import { Component, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize, take } from 'rxjs';
import { IdentityService } from '../../api/services/identity.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  standalone: false,
})
export class ForgotPasswordComponent {
  /**
   * Form used to log in for existing users
   */
  forgotPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required]),
  });

  readonly sending = signal(false);

  constructor(
    private router: Router,
    private identityService: IdentityService,
    private toastService: ToastService,
  ) {}

  /**
   * Sends a forgot password request to the server, to dispatch a reset password link
   */
  sendCode() {
    if (this.sending() || this.forgotPasswordForm.invalid) {
      return;
    }

    let successToastShown = false;
    this.sending.set(true);
    this.identityService
      .forgotPasswordPost$Response({
        body: { email: this.forgotPasswordForm.controls.email.value! },
      })
      .pipe(
        take(1),
        finalize(() => this.sending.set(false)),
      )
      .subscribe({
        next: () => {
          this.sending.set(false);
          successToastShown = true;
          this.toastService.success('Request Successful');
        },
        complete: () => {
          this.sending.set(false);
          if (!successToastShown) {
            this.toastService.success('Request Successful');
          }
        },
        error: () => {
          this.sending.set(false);
          this.toastService.error('Something Went Wrong');
        },
      });
  }

  /**
   * Navigates user back to login page
   */
  backToLogin() {
    void this.router.navigate(['/']);
  }
}
